// Shared role → portal mapping (mirrors backend ROLE_PORTAL_MAP)
export const ROLE_PORTAL_MAP = {
  participant:        "/app/home",
  staff:              "/staff/caseload",
  admin:              "/admin",
  super_admin:        "/admin",
  employer:           "/portal/employer",
  partner:            "/portal/partner",
  community_partner:  "/portal/partner",
  training_provider:  "/portal/training",
  government_agency:  "/portal/government",
  funding_org:        "/portal/funding",
  volunteer:          "/portal/volunteer",
  instructor:         "/portal/instructor",
};

// Human-readable role labels used across signup, portal picker, access-denied UX.
export const ROLE_LABELS = {
  participant:        "Participant (Job Seeker)",
  employer:           "Employer",
  partner:            "Community Partner",
  community_partner:  "Community Partner",
  training_provider:  "Training Provider",
  government_agency:  "Government Agency",
  funding_org:        "Funding Organization",
  volunteer:          "Volunteer",
  staff:              "Staff Member",
  admin:              "Administrator",
  super_admin:        "Administrator",
  instructor:         "Instructor",
};

// Roles the public may self-register as (staff/admin are invitation-only).
export const PUBLIC_SIGNUP_ROLES = [
  { value: "participant",        label: "Participant (Job Seeker)",  desc: "Explore careers, plan your next step, and work with a Case Manager." },
  { value: "employer",           label: "Employer",                   desc: "Post hiring needs, refer candidates, and manage workforce fulfillment." },
  { value: "community_partner",  label: "Community Partner",          desc: "Refer participants, coordinate programs, and share resources." },
  { value: "training_provider",  label: "Training Provider",          desc: "Deliver certifications and training pathways for COD participants." },
  { value: "government_agency",  label: "Government Agency",          desc: "Coordinate contracts, workforce initiatives, and grant partnerships." },
  { value: "funding_org",        label: "Funding Organization",       desc: "Provide grant, foundation, or investment support to COD programs." },
  { value: "volunteer",          label: "Volunteer",                  desc: "Support the mission through mentorship, events, and community work." },
];

export function portalForUser(user) {
  if (!user) return "/signin";
  const rs = user.roles && user.roles.length ? user.roles : [user.role];
  if (rs.length > 1) return "/portal";
  return ROLE_PORTAL_MAP[rs[0]] || "/app/home";
}
